var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-content", class: { colored: _vm.colored } },
    [_vm._t("default"), _vm._v(" "), _c("FooterComponent")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }